module.exports = __webpack_public_path__ + "static/media/no-profile-photo.f80e8250.png";